import clsx from 'clsx'
import type { RegimeResult } from '../../types'

interface Props {
  regime: RegimeResult | null
  loading?: boolean
}

const REGIME_CONFIG = {
  trending: {
    label:   'トレンド',
    color:   'text-trading-blue',
    bg:      'bg-trading-blue/10 border-trading-blue/30',
    dot:     'bg-trading-blue',
  },
  volatile: {
    label:   '高ボラ',
    color:   'text-trading-red',
    bg:      'bg-trading-red/10 border-trading-red/30',
    dot:     'bg-trading-red',
  },
  ranging: {
    label:   'レンジ',
    color:   'text-trading-yellow',
    bg:      'bg-trading-yellow/10 border-trading-yellow/30',
    dot:     'bg-trading-yellow',
  },
} as const

const DIR_LABEL: Record<string, string> = {
  up:   '↑ 上昇',
  down: '↓ 下降',
  none: '—',
}

export default function RegimeCard({ regime, loading }: Props) {
  if (loading) {
    return (
      <div className="rounded-lg border border-trading-border bg-trading-panel p-4 animate-pulse">
        <div className="h-4 bg-trading-border rounded w-1/3 mb-3" />
        <div className="h-8 bg-trading-border rounded w-1/2" />
      </div>
    )
  }

  if (!regime) return null

  const cfg = REGIME_CONFIG[regime.regime] ?? REGIME_CONFIG.ranging

  return (
    <div className={clsx('rounded-lg border p-4', cfg.bg)}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-[10px] text-trading-muted uppercase tracking-widest">
          市場レジーム
        </span>
        <span className={clsx('flex items-center gap-1.5 text-xs font-bold', cfg.color)}>
          <span className={clsx('w-2 h-2 rounded-full', cfg.dot)} />
          {cfg.label}
        </span>
      </div>

      <p className="text-xs text-trading-muted mb-3">{regime.description}</p>

      <div className="grid grid-cols-3 gap-2 text-center">
        <Stat label="ADX" value={regime.adx.toFixed(1)} />
        <Stat label="ATR 比率" value={regime.atr_ratio.toFixed(2)} />
        <Stat label="方向" value={DIR_LABEL[regime.direction] ?? '—'} />
      </div>
    </div>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="bg-trading-bg/60 rounded p-2">
      <p className="text-[9px] text-trading-muted mb-0.5">{label}</p>
      <p className="text-xs font-mono font-semibold text-trading-text">{value}</p>
    </div>
  )
}
